import React, { Component } from 'react';
import Select, { Creatable } from 'react-select';
import Highlighter from 'react-highlight-words';

import 'react-select/dist/react-select.css';
import iconsReactions from '../../components/Widgets/widget-reactions-plugins/icons.json';

import feathers from '../../feathers';
import auth from '../../lib/auth';

class SelectRemoteWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsSelect: [],
      isLoading: false,
    };
  }

  async componentWillMount() {
    //If Default Option Select

    this.setState({
      optionsSelect:
        this.props.defaultOptions !== undefined
          ? this.props.defaultOptions
          : [],
    });
  }

  onChange = async (event) => {
    var _this = this;
    if (event !== null) {
      if (event.className === 'Select-create-option-placeholder') {
        this.props.onCreate(event.value);
      } else {
        this.props.onChange(event.value);
      }
    } else {
      this.props.onChange('');
    }
  };

  search = async (inputValue) => {
    let _this = this;

    if (
      inputValue !== undefined &&
      inputValue !== '' &&
      inputValue !== ' ' &&
      inputValue.length > 3
    ) {
      _this._inputValue = inputValue;

      _this.setState({ isLoading: true });

      const query = {
        q: inputValue,
        franchiseId: auth.getCurrentUser().franchiseId,
      };
      let service = '';
      const type = this.props.type;
      service = type === 'clients' ? 'clients/search' : 'users/search';
      let result = await feathers.service(service).find({
        query,
      });
      var selectData = [];
      if (type === 'users') {
        result.map(function (item) {
          selectData.push({
            value: item['_id'],
            label:
              (item['firstName'] ? item['firstName'] : '') +
              ' ' +
              (item['lastName'] ? item['lastName'] : ''),
            reaction: undefined,
          });
        });
      } else {
        result.map(function (item) {
          selectData.push({
            value: item['_id'],
            label:
              (item['firstName'] ? item['firstName'] : '') +
              ' ' +
              (item['lastName'] ? item['lastName'] : '') +
              ' - ' +
              (item['phone'] ? item['phone'] : '') +
              ' - ' +
              (item['email'] ? item['email'] : ''),
            reaction: item['reaction'],
          });
        });
      }

      _this.setState({ optionsSelect: selectData, isLoading: false });
    }
  };

  renderOption = (option) => {
    if (option.reaction !== undefined) {
      return (
        <div>
          <img src={iconsReactions[option.reaction]} alt="" width={25} />{' '}
          <Highlighter
            searchWords={[this._inputValue]}
            textToHighlight={option.label}
          />
        </div>
      );
    } else {
      return option.label;
    }
  };

  render() {
    return (
      <div>
        <Select
          // isSearchable={false}
          placeholder={this.props.schema.title}
          name="singleSelect"
          value={this.props.value}
          options={this.state.optionsSelect}
          required={this.props.required}
          onChange={this.onChange}
          onInputChange={this.search}
          isLoading={this.state.isLoading}
          style={{ fontSize: 15, width: '522px' }}
          menuStyle={{ fontSize: 15 }}
          // optionRenderer={this.renderOption}
        />
      </div>
    );
  }
}

export default SelectRemoteWidget;



// WEBPACK FOOTER //
// ./src/views/Sales/widget-searchName.js